module.exports = __webpack_public_path__ + "img/Tkachenko.5dff7fc2.jpeg";